/* @ngInject */
export default function ZoneSelectionPolyService($rootScope, $timeout, $interval, ZoneSelectionStore) {
  const service = this;

  const double = 2;
  const viewMin = 0;
  const viewMax = 100;
  const maxMarkers = 20;
  const turnAlarmOffAfter = 1000;
  const turnAlarmOnFor = 1200;
  const flashTimes = 3;

  let bodyEventSet = false;
  let pointReadyToDrag = false;
  let shadowReadyToDrag = false;
  let placeMarker = false;
  let deleteMarker = false;
  let didntLeaveSvg = true;
  let mouseDowned = false;

  let markerAmt = 0;

  let alarmInt;
  let currentPointInd;
  let shadowClickCoord;
  let coords;
  let translateX;
  let translateY;
  let transString;
  let movingLines;

  service.state = ZoneSelectionStore.state;

  service.assignPathActiveZone = assignPathActiveZone;
  service.getPathCoordinates = getPathCoordinates;
  service.destroy = destroy;
  service.placePathMarker = placePathMarker;
  service.enablePointDragAndMarkerDeletion = enablePointDragAndMarkerDeletion;
  service.dragMarkerOrPath = dragMarkerOrPath;
  service.cancelAllDragAndAddOrDeleteMarker = cancelAllDragAndAddOrDeleteMarker;
  service.initiatePathDragOrPlaceMarker = initiatePathDragOrPlaceMarker;
  service.enableMarkerPlacement = enableMarkerPlacement;
  service.cancelMarkerPlacement = cancelMarkerPlacement;
  service.testForIntersections = testForIntersections;
  service.triggerAlarm = triggerAlarm;
  service.resetAlarmPath = resetAlarmPath;


  /**
   * Sets vmd property in store to true to notify component of polygonal compatibility, copies data array to store's
   * pathCoords property, assembles the path element's 'd' attribute, enables the svg
   *
   * @param {object} triggers - data property is an array of arrays containing coordinates, 0: x, 1: y
   */
  function assignPathActiveZone(triggers) {
    service.state.vmd = true;

    service.state.pathCoords = angular.copy(triggers);
    coords = service.state.pathCoords;

    if (coords.length > double) {
      assembleThePoints(coords);
      resetAlarmPath();
    }

    if (alarmInt) {
      $interval.cancel(alarmInt);
      service.state.alarmOn = false;
    }

    if (!bodyEventSet) {
      // Add the canceling method to the body element
      $('body').on('touchend mouseup', cancelAllDragAndAddOrDeleteMarker);
      bodyEventSet = true;
    }
    service.state.enabled = true;
  }

  /**
   * For use by other components/services to get the coordinates
   *
   * @returns {Array<Array<object>>} Coordinates
   */
  function getPathCoordinates() {
    return coords;
  }

  /**
   * Resets data in service and store, since services and value recipes retain state, and disables svg
   *
   * @returns {undefined}
   */
  function destroy() {
    _.assign(service.state, {
      svg: null,
      pt: null,
      polyGroup: null,
      polyMask: null,
      pathCoords: [],
      polyPoints: '',
      enabled: false,
      showDetectionSize: false,
      enableRectSelector: false,
      enableRectShadow: false,
      enableResizeGroup: false
    });
    _.mapValues(service.state.rectCoords, () => null);
    currentPointInd = null;

    // Remove event bindings
    $('body').off('touchend mouseup', cancelAllDragAndAddOrDeleteMarker);
    bodyEventSet = false;
  }

  function placePathMarker(evt) {
    evt.stopPropagation();
    if (didntLeaveSvg && placeMarker && markerAmt < maxMarkers) {
      const { x, y } = cursorPoint(evt);
      if (coords.length > 1) {
        let result = findInsertIndexOfNearestLineSegment([x, y], coords);
        result = coords[result + 1] ? result + 1 : 0;
        coords.splice(result, 0, [x, y]);
        assembleThePoints(coords);
      } else {
        coords.push([x, y]);
      }
    } else {
      didntLeaveSvg = true;
    }
  }

  function enablePointDragAndMarkerDeletion(evt, ind) {
    evt.stopPropagation();
    pointReadyToDrag = true;
    deleteMarker = true;
    currentPointInd = ind;
  }

  function dragMarkerOrPath(evt) {
    evt.stopPropagation();

    if (pointReadyToDrag && _.isNumber(currentPointInd)) {
      if (!movingLines) {
        movingLines = new MarkerMoveLines();
        const [line1, line2] = movingLines;
        const line1Prev = _.get(coords, [currentPointInd - 1], false) || coords[coords.length - 1];
        const line2Next = _.get(coords, [currentPointInd + 1], false) || coords[0];
        line1.setAttribute('x1', line1Prev[0]);
        line1.setAttribute('y1', line1Prev[1]);
        line2.setAttribute('x1', line2Next[0]);
        line2.setAttribute('y1', line2Next[1]);
        service.state.polyGroup.append(line1);
        service.state.polyGroup.append(line2);
      }

      const { x, y } = cursorPoint(evt);

      deleteMarker = false;

      const [line1, line2] = movingLines;
      const xCheck = x < viewMin || x > viewMax;
      const yCheck = y < viewMin || y > viewMax;
      if (!xCheck) {
        coords[currentPointInd][0] = x;
        line1.setAttribute('x2', x);
        line2.setAttribute('x2', x);
      }
      if (!yCheck) {
        coords[currentPointInd][1] = y;
        line1.setAttribute('y2', y);
        line2.setAttribute('y2', y);
      }
    } else if (shadowReadyToDrag) {
      placeMarker = false;

      const { x, y } = cursorPoint(evt);
      const transCoords = calcDiff(shadowClickCoord, x, y);
      const [moveX, moveY] = checkForBBoxCollision(transCoords[0], transCoords[1]);

      transString = 'matrix(1, 0, 0, 1,';
      if (moveX) {
        translateX = transCoords[0];
        transString += transCoords[0];
      } else {
        transString += translateX || 0;
      }
      transString += ',';
      if (moveY) {
        translateY = transCoords[1];
        transString += transCoords[1];
      } else {
        transString += translateY || 0;
      }
    }
  }

  function cancelAllDragAndAddOrDeleteMarker(evt) {
    evt.stopPropagation();
    shadowReadyToDrag = false;
    pointReadyToDrag = false;
    mouseDowned = false;

    if (translateX || translateY) {
      const results = calcNewMarkerPositions(translateX, translateY, coords);
      for (const [i, result] of results.entries()) {
        coords[i] = result;
      }
    }

    // Always call placePathMarker, it will validate placement
    placePathMarker(evt);
    placeMarker = false;

    if (deleteMarker) {
      deleteMarker = false;
      coords.splice(currentPointInd, 1);
    }

    if (movingLines) {
      $('.moving-line').remove();
      movingLines = null;
    }

    if (coords.length > double) {
      assembleThePoints(coords);
    }

    translateX = null;
    translateY = null;
    // this method is called from the attached event listener on the body element, angular needs to know
    $rootScope.$apply(() => {
      service.state.polyGroup[0].style.transform = 'none';
      transString = 'none';

      if (_.isNumber(currentPointInd)) {
        service.state.polyZoneShadow[0].style.fill = testForIntersections() ?
          'rgba(238, 8, 8, 0.56)' : 'rgba(0, 0, 0, .0001)';
      }
      currentPointInd = null;
    });
  }

  function initiatePathDragOrPlaceMarker(evt) {
    evt.stopPropagation();
    shadowReadyToDrag = true;
    shadowClickCoord = cursorPoint(evt);
    placeMarker = true;
    mouseDowned = true;

    window.requestAnimationFrame(requestPolyGroupUpdate);
  }

  function enableMarkerPlacement($event) {
    $event.stopPropagation();
    placeMarker = true;
  }

  function cancelMarkerPlacement() {
    didntLeaveSvg = false;
  }

  function testForIntersections() {
    const lastLine = [coords[coords.length - 1], coords[0]];

    for (let i = 0; i < coords.length - 1; i += 1) {
      const currentLine = [coords[i], coords[i + 1]];

      for (let j = i + 1; j < coords.length - 1; j += 1) {
        const compareLine = [coords[j], coords[j + 1]];

        if (currentLine[1][0] !== compareLine[0][0] && currentLine[1][1] !== compareLine[0][1] &&
            intersects(currentLine[0], currentLine[1], compareLine[0], compareLine[1])) {
          return true;
        }
      }
      // Checking against final line made of last and first points, since it won't be included in iterations
      if (currentLine[1][0] !== lastLine[0][0] && currentLine[1][1] !== lastLine[0][1] &&
          intersects(currentLine[0], currentLine[1], lastLine[0], lastLine[1])) {
        return true;
      }
    }
    return false;
  }

  function triggerAlarm() {
    alarmInt = $interval(() => {
      service.state.alarmOn = true;

      $timeout(() => {
        service.state.alarmOn = false;
      }, turnAlarmOffAfter);
    }, turnAlarmOnFor, flashTimes);
  }

  function resetAlarmPath() {
    service.state.alarmPath = service.state.polyPoints;
  }

  /* ************************* */
  /* ********* Utils ********* */
  /* ************************* */

  function cursorPoint(evt, element) {
    if (evt.type.slice(0, 5) === 'touch') {
      evt = _.has(evt, ['touches', '0']) ? evt.touches[0] : evt.originalEvent.changedTouches[0];
    }
    service.state.pt.x = evt.clientX;
    service.state.pt.y = evt.clientY;
    return angular.isUndefined(element) ?
      service.state.pt.matrixTransform(service.state.svg.getScreenCTM().inverse()) :
      service.state.pt.matrixTransform(element.getScreenCTM().inverse());
  }

  function assembleThePoints(co) {

    let i = 0;
    let temp = '';
    while (i < co.length) {
      temp += `${co[i][0]},${co[i][1]} `;
      i += 1;
    }
    markerAmt = co.length;

    service.state.polyPoints = temp;
  }

  function MarkerMoveLines() {
    const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line1.classList.add('moving-line');
    const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line2.classList.add('moving-line');

    return [line1, line2];
  }

  function checkForBBoxCollision(offsetX, offsetY, temp = [true, true]) {
    const bBox = service.state.polyZoneShadow[0].getBBox();

    // offsets are the distance moved from original mousedown coords, since BBox will not change when using transform
    bBox.x += offsetX;
    bBox.y += offsetY;

    if (bBox.x < 0 || bBox.x + bBox.width > 100) {
      temp[0] = false;
    }
    if (bBox.y < 0 || bBox.y + bBox.height > 100) {
      temp[1] = false;
    }

    return temp;
  }

  function requestPolyGroupUpdate() {
    if (mouseDowned) {
      window.requestAnimationFrame(requestPolyGroupUpdate);
      service.state.polyGroup[0].style.transform = `${transString})`;
    }
  }

  function calcNewMarkerPositions(xDiff, yDiff, co, temp = []) {
    let i = 0;
    while (i < co.length) {
      const newX = co[i][0] + xDiff;
      const newY = co[i][1] + yDiff;

      temp.push([
        newX,
        newY
      ]);

      i += 1;
    }

    return temp;
  }

  function calcDiff(origin, x, y) {
    return [x - origin.x, y - origin.y];
  }

  function intersects([x1, y1], [x2, y2], [x3, y3], [x4, y4]) {
    const det = ((x2 - x1) * (y4 - y3)) - ((x4 - x3) * (y2 - y1));
    if (det === 0) {
      return false;
    }
    const lambda = (((y4 - y3) * (x4 - x1)) + ((x3 - x4) * (y4 - y1))) / det;
    const gamma = (((y1 - y2) * (x4 - x1)) + ((x2 - x1) * (y4 - y1))) / det;
    return (lambda > 0 && lambda < 1) && (gamma > 0 && gamma < 1);
  }

  function findInsertIndexOfNearestLineSegment(origin, arrs) {
    let specialInd;
    let smallestDis = Number.MAX_SAFE_INTEGER;

    for (let i = 0; i < arrs.length; i += 1) {
      const currentDis = distToSegment(origin, arrs[i], arrs[i + 1] ? arrs[i + 1] : arrs[0]);
      if (currentDis < smallestDis) {
        smallestDis = currentDis;
        specialInd = i;
      }
    }

    return specialInd;
  }

  /*
        The determinant is how far along the line segment that the projection falls.
        So if it is 0 the projection falls right on v; if it's 1, it's on w; if it's 0.5, it's halfway between.
        If it is less than 0 or greater than 1, it falls on the line past one end or the other of the segment.
        In that case the distance to the segment will be the distance to the nearer end.
    */
  function distToSegment(p1, v2, w3) {
    const [x1, y1] = p1;
    const [x2, y2] = v2;
    const [x3, y3] = w3;
    const l2 = dist2(v2, w3);
    if (l2 === 0) {
      return dist2(p1, v2);
    }

    const determinant = (((x1 - x2) * (x3 - x2)) + ((y1 - y2) * (y3 - y2))) / l2;
    const i = Math.max(0, Math.min(1, determinant));

    return dist2(p1, [x2 + (i * (x3 - x2)), y2 + (i * (y3 - y2))]); // order of operations must be as such!!!
  }

  function dist2([x1, y1], [x2, y2]) {
    return ((x1 - x2) ** double) + ((y1 - y2) ** double);
  }
}
